// extracted by mini-css-extract-plugin
export default {"entityNav":"Entity_entityNav__kbq+J"};